import React from 'react';
import { DependentsQuantityBlobStyled } from './styles';
import { DEPENDENTS_QUANTITY_BLOB_TEST_ID } from '../constants';

interface Props {
  dependentsNumber: number;
}

export const DependentsQuantity: React.FC<Props> = ({ dependentsNumber }) => {
  return dependentsNumber > 0 ? (
    <DependentsQuantityBlobStyled data-test-id={DEPENDENTS_QUANTITY_BLOB_TEST_ID}>
      + {dependentsNumber}
    </DependentsQuantityBlobStyled>
  ) : null;
};
